import { FormattedMessage, useIntl } from 'react-intl';
import { useState } from 'react';
import { DialogWindow } from '@/components/Dialog.tsx';
import { ProfilePicker } from './ProfilePicker';
import Button from './core/Button';
import { IconRefresh } from '@/icons';

export function ProfilePickerButton() {
  const { formatMessage } = useIntl();

  const [open, setOpen] = useState<boolean>(false);

  return (
    <DialogWindow
      title={formatMessage({ defaultMessage: 'Välj profil' })}
      className="max-w-lg"
      content={<ProfilePicker onSelect={() => setOpen(false)} />}
      dialogTrigger={
        <Button
          variant="ghost"
          className="h-14 w-full"
          startIcon={<IconRefresh />}
        >
          <FormattedMessage defaultMessage="Byt profil" />
        </Button>
      }
      onOpenChange={setOpen}
      open={open}
    />
  );
}
